export default __webpack_public_path__ + "static/media/269.e66f046c.jpg";